<template>
    <div :class="wrapperClass">
        <FormInput
            :label="label"
            :type="type"
            :max="computedMax"
            :min="computedMin"
            :name="name"
            :id="id"
            :rules="computedRules"
            :value="value"
            :disabled="disabled"
            :style="inputStyle"
            :data-cy="dataCy"
            :dateValidation="dateValidation"
            @input="updateValue"
        />
    </div>
</template>

<script setup>
    import { computed } from 'vue'

    const props = defineProps({
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: 'Fecha'
        },
        name: {
            type: String,
            default: 'fecha'
        },
        id: {
            type: String,
            default: 'fecha'
        },
        type: {
            type: String,
            default: 'date'
        },
        rules: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        wrapperClass: {
            type: String,
            default: 'col-md-4 col-12 mt-3'
        },
        inputStyle: {
            type: String,
            default: ''
        },
        min: {
            type: String,
            default: null
        },
        max: {
            type: String,
            default: null
        },
        dataCy: {
            type: String,
            required: true
        },
        dateValidation: {
            type: String,
            default: 'noFuture'
        }
    })

    const emit = defineEmits(['input'])

    const updateValue = val => {
        emit('input', val)
    }

    const computedMax = computed(() => props.max || null)
    const computedMin = computed(() => props.min || null)

    const computedRules = computed(() => props.rules || '')
</script>
